import QuoteIllustration from '../components/illustrations/QuoteIllustration.jsx';
import ProjectsIllustration from '../components/illustrations/ProjectsIllustration.jsx';
import InvoicesIllustration from '../components/illustrations/InvoicesIllustration.jsx';
import CashIllustration from '../components/illustrations/CashIllustration.jsx';

/** The current site for single companies lives under this path. */
export const SMB_BASE = '/smb';

/**
 * The four things Revetall does, in the order a job runs: quote, project, invoice, cash.
 * Each gets a card on the /smb front page and its own page at `path`.
 * Texts live under `features.<id>` in the SMB translations. Next to the steps the feature page
 * shows a chat (`features.<id>.chat`), a warning email (`features.<id>.email`, when `demo` is
 * 'email') or a screen from the app (`features.<id>.app`, when `demo` is 'app').
 */
export const FEATURES = [
  { id: 'erfaringstall', path: `${SMB_BASE}/erfaringstall`, Illustration: QuoteIllustration },
  { id: 'prosjekter', path: `${SMB_BASE}/prosjekter`, Illustration: ProjectsIllustration, demo: 'email' },
  { id: 'fakturaer', path: `${SMB_BASE}/fakturaer`, Illustration: InvoicesIllustration, demo: 'app' },
  { id: 'likviditet', path: `${SMB_BASE}/likviditet`, Illustration: CashIllustration, demo: 'email' },
];
